import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

import AppContext from '../../utility/AppContext';
import Layouts from './Layouts';
import { ContentView } from '../../index';
import useStyles from '../../../shared/jss/common/common.style';
import { useThemeAssets } from '../../../shared/customHooks/useThemeAssets';
const useStyle = makeStyles(() => ({
  appAuth: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    height: '100vh',
    backgroundColor: '#f3f4f6',
    // background: `url(/assets/images/home-background.png) no-repeat center center`,
    backgroundSize: 'cover',

    '& .scrollbar-container': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    '& .main-content-view': {
      padding: 0,
      flex: 1,
    },
    '& .footer': {
      marginRight: 0,
      marginLeft: 0,
    },
  },
}));

const CremaLayout = () => {
  useStyles();
  const { navStyle } = useContext(AppContext);
  const { user } = useSelector(({ auth }) => auth);
  const AppLayout = Layouts[navStyle];
  const { loginBackground } = useThemeAssets();

  const classes = useStyle();
  return (
    <>
      {user ? (
        <AppLayout />
      ) : (
        <Box className={classes.appAuth} style={{
          backgroundImage: `${loginBackground}`,
        }}
        >
          <ContentView />
        </Box>
      )}
    </>
  );
};

export default React.memo(CremaLayout);
